const updateTimelines = () => {
    const timelines = [...document.querySelectorAll(".timeline")];
    timelines.forEach((timeline) => {
        const track = timeline.querySelector(".timeline__track");
        const last_item = timeline.querySelector(
            ".timeline__items > :last-child",
        );

        if (!track || !last_item) {
            return;
        }

        const last_year = last_item.querySelector(".timeline__item-year");
        const last_box = last_item.querySelector(".timeline__item-box");

        if (!last_year || !last_box) {
            return;
        }

        const last_year_height = last_year.getBoundingClientRect().height;
        const last_box_height = last_box.getBoundingClientRect().height;
        track.style.bottom = last_box_height - last_year_height / 2 + "px";
        timeline.classList.add("loaded");
    });
};

export default updateTimelines;
